import { parse, isValid, format as formatDateFns } from 'date-fns';
import Fuse from 'fuse.js';

export const parseDateString = (dateString) => {
    if (!dateString) return null;
    const formats = ['dd/MM/yyyy', 'yyyy-MM-dd', "yyyy-MM-dd'T'HH:mm:ss.SSSxxx"];
    for (const fmt of formats) {
        const parsedDate = parse(dateString, fmt, new Date());
        if (isValid(parsedDate)) {
            return formatDateFns(parsedDate, 'yyyy-MM-dd');
        }
    }
    return null;
};

export const parseValue = (valueString) => {
    if (typeof valueString !== 'string' && typeof valueString !== 'number') return 0;
    let cleanedString = String(valueString).replace('R$', '').trim();

    const thousandsSeparator = '.';
    const decimalSeparator = ',';

    const hasThousand = cleanedString.includes(thousandsSeparator);
    const hasDecimal = cleanedString.includes(decimalSeparator);

    if (hasThousand && hasDecimal && cleanedString.lastIndexOf(thousandsSeparator) < cleanedString.lastIndexOf(decimalSeparator)) {
        cleanedString = cleanedString.replace(/\./g, '').replace(',', '.');
    } else if (hasThousand && !hasDecimal) {
        cleanedString = cleanedString.replace(/\./g, '');
    } else if (hasDecimal) {
        cleanedString = cleanedString.replace(',', '.');
    }

    return parseFloat(cleanedString) || 0;
};

/**
 * Extrai o número TOTAL de parcelas de qualquer formato:
 * "1 de 3" → 3, "1/3" → 3, "3" → 3, "À vista" → 1, "" → 1, null → 1
 */
export const extractTotalParcelas = (parcelasRaw) => {
    if (!parcelasRaw) return 1;
    const str = String(parcelasRaw).trim().toLowerCase();
    if (!str || str === '0' || str.includes('vista')) return 1;

    // Tenta "X de Y" ou "X/Y" — pega o último número
    const match = str.match(/(\d+)\s*(?:de|\/)\s*(\d+)/i);
    if (match) {
        return parseInt(match[2], 10) || 1;
    }

    // Número puro "3", "12"
    const num = parseInt(str, 10);
    return num > 0 ? num : 1;
};

export const calculateStatus = (valorCompra, valorRecebido, parcelasRaw) => {
    const total = parseFloat(valorCompra) || 0;
    const recebido = parseFloat(valorRecebido) || 0;

    // Se a venda for de valor 0, tratamos como quitada se houver qualquer recebimento ou 0
    if (total <= 0) return recebido >= 0 ? 'Quitado' : 'Em Aberto';

    const totalParcelas = extractTotalParcelas(parcelasRaw);

    if (totalParcelas <= 1) {
        // Parcela única (À vista, Débito, PIX, iFood): qualquer recebimento quita
        return recebido > 0 ? 'Quitado' : 'Em Aberto';
    }

    // Parcelado (2x ou mais): exige >= 80% do valor total
    const percentualRecebido = recebido / total;
    return percentualRecebido >= 0.8 ? 'Quitado' : 'Em Aberto';
};

export const findClosestMatch = (inputValue, list) => {
    if (!inputValue) return null;

    const inputLower = inputValue.toLowerCase();

    for (const item of list) {
        if (inputLower.includes(item.name.toLowerCase())) {
            return item.name;
        }
    }

    const fuse = new Fuse(list, {
        keys: ['name'],
        includeScore: true,
        threshold: 0.4,
        findAllMatches: false,
    });

    const results = fuse.search(inputValue);
    if (results.length > 0) {
        return results[0].item.name;
    }

    return inputValue;
};